import { hmacSHAsign } from "@/utils/encrypt.js";
export function getOssOnlineImgFile(imgPath) {
  try {
    const current = process.env.NODE_ENV;
      const urlLinkPre =
          current == "development" || current == "testing"
              ? "https://developh5.myroki.com"
              : "https://h5.myroki.com";
     //https://developh5.myroki.com/activityAssetsImgs/preActivityImgs/
      return `${urlLinkPre}/activityAssetsImgs/preActivityImgs/${imgPath}`;
   
  } catch (error) {
      console.warn(error);
  }
}
export function savePicture(Url) {
  var blob = new Blob([""], { type: "application/octet-stream" });
  var url = URL.createObjectURL(blob);
  var a = document.createElement("a");
  a.href = Url;
  a.download = Url.replace(/(.*\/)*([^.]+.*)/gi, "$2").split("?")[0];
  var e = document.createEvent("MouseEvents");
  e.initMouseEvent(
    "click",
    true,
    false,
    window,
    0,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    0,
    null
  );
  a.dispatchEvent(e);
  URL.revokeObjectURL(url);
}
export function getBase64(url, outputFormat = "image/png") {
  return new Promise(function(resolve, reject) {
    let canvas = document.createElement("CANVAS"),
      ctx = canvas.getContext("2d"),
      img = new Image();
    img.crossOrigin = "Anonymous"; // 重点！设置image对象可跨域请求
    img.onload = function() {
      console.log("img----", img);
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      let dataURL = canvas.toDataURL(outputFormat);
      canvas = null;
      //   console.log("dataURL----", dataURL ? 1 : 0);
      resolve(dataURL);
    };
    img.onerror = function(e) {
      console.log("图片加载出错", url, e);
      reject("加载出错");
    };
    img.src = url;
  });
}
export function getBase64AllImgs(urlListsObj, outputFormat = "image/png") {
  let promiseArr = [];
  const imgPreloader = url => {
    return new Promise(function(resolve, reject) {
      let canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous"; // 重点！设置image对象可跨域请求
      img.onload = function() {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        let dataURL = canvas.toDataURL(outputFormat);
        canvas = null;
        resolve(dataURL);
      };
      img.src = url;
    });
  };

  for (let key in urlListsObj) {
    promiseArr.push(imgPreloader(urlListsObj[key]));
  }
  // urlLists.forEach(element => {
  //   promiseArr.push(imgPreloader(element));
  // });
  return Promise.all(promiseArr);
}
export const imgsPreloader = imgs => {
  let promiseArr = [];
  const imgPreloader = url => {
    return new Promise((resolve, reject) => {
      let image = new Image();
      image.onload = () => {
        resolve();
      };
      image.onerror = () => {
        reject();
      };
      image.src = url;
    });
  };
  imgs.forEach(element => {
    promiseArr.push(imgPreloader(element));
  });
  return Promise.all(promiseArr);
};
export const imgPreload = img => {
  return new Promise((resolve, reject) => {
    let image = new Image();
    image.onload = () => {
      console.log("成功了----");
      resolve("成功了");
    };
    image.onerror = () => {
      console.error("err");
      reject();
    };
    image.src = img;
  });
};
export function getImageWidth(file) {
  //  图片的宽高
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.addEventListener(
      "load",
      function() {
        var imageObj = new Image();
        imageObj.src = reader.result;
        imageObj.onload = function() {
          console.log(imageObj.width + imageObj.height);
          // 执行上传的方法，获取外网路径，上传进度等
          //  debugger;
          const meta = {
            width: imageObj.width,
            height: imageObj.height
          };
          resolve(meta);
        };
      },
      false
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  });
}
//获取随机位数的字符串
export function randomString(length) {
  var str = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var result = "";
  for (var i = length; i > 0; --i)
    result += str[Math.floor(Math.random() * str.length)];
  return result;
}
export function isPhone(number) {
  const reg = /^1[3456789]\d{9}$/;
  return reg.test(number);
}
export function isEmoji(val) {
  const reg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
  return reg.test(val);
}
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}
export function compareTime(stime, etime) {
  // 转换时间格式，并转换为时间戳
  function tranDate(time) {
    return new Date(time.replace(/-/g, "/")).getTime();
  }
  // 开始时间
  let startTime = tranDate(stime);
  // 结束时间
  let endTime = tranDate(etime);
  console.log("startTime", startTime, "endTime", endTime);
  let thisDate = new Date();
  // 获取当前时间，格式为 2018-9-10 20:08
  let currentTime =
    thisDate.getFullYear() +
    "-" +
    (thisDate.getMonth() + 1) +
    "-" +
    thisDate.getDate() +
    " " +
    thisDate.getHours() +
    ":" +
    thisDate.getMinutes() +
    ":" +
    thisDate.getSeconds();
  let nowTime = tranDate(currentTime);
  // 如果当前时间处于时间段内，返回true，否则返回false
  if (nowTime < startTime) {
    return "before";
  }
  if (nowTime > endTime) {
    return "after";
  }
  return "inner";
}

export function dateDuring(ytime) {
  // 转换时间格式，并转换为时间戳
  function tranDate(time) {
    return new Date(time.replace(/-/g, "/")).getTime();
  }
  // 开始时间
  let xTime = tranDate(ytime);
  console.log("xTime", xTime);
  let thisDate = new Date();
  // 获取当前时间，格式为 2018-9-10 20:08:09
  let currentTime =
    thisDate.getFullYear() +
    "-" +
    (thisDate.getMonth() + 1) +
    "-" +
    thisDate.getDate() +
    " " +
    thisDate.getHours() +
    ":" +
    thisDate.getMinutes() +
    ":" +
    thisDate.getSeconds();
  let nowTime = tranDate(currentTime);
  // 如果当前时间处于时间段内，返回true，否则返回false
  if (nowTime < xTime) {
    const duringStamp = xTime - nowTime;
    return duringStamp;
  }
}

//手机号脱敏
export function noPassByMobile(str) {
  if (null != str && str != undefined) {
    var pat = /(\d{3})\d*(\d{4})/;
    return str.replace(pat, "$1****$2");
  } else {
    return "";
  }
}
export function cleanDom(node) {
  for (var n = 0; n < node.childNodes.length; n++) {
    var child = node.childNodes[n];
    if (
      child.nodeType === 8 ||
      (child.nodeType === 3 && !/\S/.test(child.nodeValue))
    ) {
      node.removeChild(child);
      n--;
    } else if (child.nodeType === 1) {
      cleanDom(child);
    }
  }
}
export function getRandomArrayElements(arr, count) {
  var shuffled = arr.slice(0),
    i = arr.length,
    min = i - count,
    temp,
    index;
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }
  return shuffled.slice(min);
}

export const flagInitData = [
  {
    name: "烟机",
    bg: getOssOnlineImgFile("flag/yj.png"),
    labelBg: getOssOnlineImgFile("flag/yj_label.png"),
    flagList: [
      {
        value: 1,
        checked: false,
        text: "每日护肤 告别油腻"
      },
      {
        value: 2,
        checked: false,
        text: "拒绝熬夜，保卫发际线"
      },
      {
        value: 3,
        checked: false,
        text: "每周健身三次"
      },
      {
        value: 4,
        checked: false,
        text: "减龄瘦肩 背薄一寸"
      },
      {
        value: 5,
        checked: false,
        text: "我要戒烟，健康生活"
      },
      {
        value: 6,
        checked: false,
        text: "保持自律 实现蜕变"
      },
      {
        value: 7,
        checked: false,
        text: "上得厅堂 下得厨房"
      },
      {
        value: 8,
        checked: false,
        text: "不再容貌焦虑"
      },
      {
        value: 9,
        checked: false,
        text: "做一个精致的猪猪女孩/男孩"
      },
      {
        value: 10,
        checked: false,
        text: "减肥10斤，不瘦不吃火锅"
      }
    ]
  },
  {
    name: "灶具",
    bg: getOssOnlineImgFile("flag/zj.png"),
    labelBg: getOssOnlineImgFile("flag/zj_label.png"),
    flagList: [
      {
        value: 12,
        checked: false,
        text: "告别外卖 每周开火三次"
      },
      {
        value: 13,
        checked: false,
        text: "生意火爆 客流翻倍"
      },
      {
        value: 14,
        checked: false,
        text: "上分上星上王者"
      },
      {
        value: 15,
        checked: false,
        text: "升职加薪 收入再加1个0"
      },
      {
        value: 16,
        checked: false,
        text: "考神附体 逢考必过"
      },
      {
        value: 17,
        checked: false,
        text: "实现财务自由"
      },
      {
        value: 18,
        checked: false,
        text: "基金不绿，股票长红"
      },
      {
        value: 19,
        checked: false,
        text: "桃花旺旺，马上脱单"
      },
      {
        value: 20,
        checked: false,
        text: "上岸！上岸！上岸！"
      },
      {
        value: 21,
        checked: false,
        text: "运势爆破 中彩票大奖"
      }
    ]
  },
  {
    name: "消毒柜",
    bg: getOssOnlineImgFile("flag/xdg.png"),
    labelBg: getOssOnlineImgFile("flag/xdg_label.png"),
    flagList: [
      {
        value: 23,
        checked: false,
        text: "疫情消散 告别口罩"
      },
      {
        value: 24,
        checked: false,
        text: "病毒退退退，不做小阳人"
      },
      {
        value: 25,
        checked: false,
        text: "降低emo 百“毒”不侵"
      },
      {
        value: 26,
        checked: false,
        text: "养生早起不熬夜"
      },
      {
        value: 27,
        checked: false,
        text: "保持好心情，爱自己是终身浪漫的开始"
      },
      {
        value: 28,
        checked: false,
        text: "脱单脱贫不脱发"
      },
      {
        value: 29,
        checked: false,
        text: "减少焦虑 摆脱失眠"
      },
      {
        value: 30,
        checked: false,
        text: "按时吃三餐"
      },
      {
        value: 31,
        checked: false,
        text: "保持房间整洁，每周打扫"
      },
      {
        value: 32,
        checked: false,
        text: "检查一次幽门螺旋杆菌"
      }
    ]
  },
  {
    name: "全家福",
    bg: getOssOnlineImgFile("flag/qjf.png"),
    labelBg: getOssOnlineImgFile("flag/qjf_label.png"),
    flagList: [
      {
        value: 34,
        text: " 每周为家人做一顿饭",
        checked: false
      },
      {
        value: 35,
        checked: false,
        text: "组建自己的小家"
      },
      {
        value: 36,
        checked: false,
        text: "每周和远方亲友打一次视频电话"
      },
      {
        value: 37,
        checked: false,
        text: "定期丢掉不合适不好用的东西"
      },
      {
        value: 38,
        checked: false,
        text: "每周一次亲子互动"
      },
      {
        value: 39,
        checked: false,
        text: "带爸妈体检一次"
      },
      {
        value: 40,
        checked: false,
        text: "带家人旅游一次"
      },
      {
        value: 41,
        checked: false,
        text: "定期组织家庭聚会"
      },
      {
        value: 42,
        checked: false,
        text: "回家陪爸妈过年"
      },
      {
        value: 43,
        checked: false,
        text: "给爸妈换一个大件"
      }
    ]
  }
];
export const flagWinnerList = [
  {
    rank: 23,
    rankName: "一等奖",
    rewardName: "烟机5009S 1台",
    url: getOssOnlineImgFile("flag/reward_yj.png")
  },
  {
    rank: 24,
    rankName: "二等奖",
    rewardName: "灶具9B315 1台",
    url: getOssOnlineImgFile("flag/reward_zj.png")
  },
  {
    rank: 25,
    rankName: "三等奖",
    rewardName: "消毒柜XZ822 1台",
    url: getOssOnlineImgFile("flag/reward_xdg.png")
  },
  {
    rank: 26,
    rankName: "四等奖",
    rewardName: "火鸡消毒筷架 1个",
    url: getOssOnlineImgFile("flag/reward_xdj.png")
  },
  {
    rank: 27,
    rankName: "五等奖",
    rewardName: "中式炒锅 1个",
    url: getOssOnlineImgFile("flag/reward_chg.png")
  },
  {
    rank: 28,
    rankName: "六等奖",
    rewardName: "煲仔锅 1个",
    url: getOssOnlineImgFile("flag/reward_guo.png")
  },
  {
    rank: 29,
    rankName: "七等奖",
    rewardName: "50元京东e卡",
    url: getOssOnlineImgFile("flag/reward_jd50.png")
  },
  {
    rank: 30,
    rankName: "八等奖",
    rewardName: "30元京东e卡",
    url: getOssOnlineImgFile("flag/reward_jd30.png")
  },
  {
    rank: 9,
    rankName: "九等奖",
    rewardName: "厨电焕新优惠券",
    url: getOssOnlineImgFile("flag/reward_quan.png")
  }
];
export const winnerList = [
  {
    rank: 6,
    rankName: "一等奖",
    rewardName: "康佳扫地机",
    url:"https://developh5.myroki.com/activityAssetsImgs/preActivityImgs/saodiji.png"
  },
  {
    rank: 7,
    rankName: "二等奖",
    rewardName: "高级珐琅锅",
    url: "https://developh5.myroki.com/activityAssetsImgs/preActivityImgs/falangguo.png"
  },
  {
    rank: 8,
    rankName: "三等奖",
    rewardName: "红米无线耳机",
    url: "https://developh5.myroki.com/activityAssetsImgs/preActivityImgs/erji.png"
  },
  {
    rank: 9,
    rankName: "四等奖",
    rewardName: "多肉小盆栽",
    url: "https://developh5.myroki.com/activityAssetsImgs/preActivityImgs/penzai.png"
  }
];

export const encourageList = [
  "狂吃不胖",
  "欧气爆棚",
  "暴富在即",
  "平安喜乐",
  "大吉大利",
  "心想事成",
  "万事胜意",
  "升职加薪",
  "发量富翁",
  "颜值暴增"
];
export const rewardWinnerList = [
  {
    rank: 11,
    rankName: "特等奖",
    rewardName: "西屋破壁机",
 
    url:getOssOnlineImgFile('618Activity/prize_0.png'),
    unit: "台"
  },
  {
    rank: 12,
    rankName: "一等奖",
    rewardName: "中式炒锅",
 
    url:getOssOnlineImgFile('618Activity/prize_1.png'),
    unit: "个"
  },
  {
    rank: 13,
    rankName: "二等奖",
    rewardName: "煲仔锅",
 
    url:getOssOnlineImgFile('618Activity/prize_2.png'),
    unit: "个"
  },
  {
    rank: 14,
    rankName: "三等奖",
    rewardName: "厨房养护套组",
 
    url:getOssOnlineImgFile('618Activity/prize_3.png'),
    unit: "套"
  },
  {
    rank: 15,
    rankName: "参与奖",
    rewardName: "厨小布",
  
    url:getOssOnlineImgFile('618Activity/prize_join.png'),
    unit: "卷"
  }
];
export function getRequest() {
  //debugger
  var url = decodeURIComponent(location.search); // 获取url中"?"符后的字串
  console.log(url);
  var theRequest = {};
  if (url.indexOf("?") !== -1) {
    var str = url.substr(1);
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  //debugger
  console.log(theRequest);
  return theRequest;
}
//九宫格抽奖奖品
export const rewardRoundWinnerList = [
  {
    rank: 17,
    rewardName: "灶具9B315",
    stopIndex: 0,
    url: getOssOnlineImgFile("zaojuLottery/9b315.png")
  },
  {
    rank: 22,
    rewardName: "厨小布",
    stopIndex: 1,
    url: getOssOnlineImgFile("zaojuLottery/reward_chuxiaobu.png")
  },
  {
    rank: 20,
    rewardName: "厨房养护6件套",
    stopIndex: 2,
    url: getOssOnlineImgFile("zaojuLottery/reward_liujiantao.png")
  },
  {
    rank: 18,
    rewardName: "中式烹饪炒锅",
    stopIndex: 3,
    url: getOssOnlineImgFile("zaojuLottery/reward_chaoguo.png")
  },
  {
    rank: 19,
    rewardName: "透明雨伞",
    stopIndex: 5,
    url: getOssOnlineImgFile("zaojuLottery/reward_yusan.png")
  },
  {
    rank: 6,
    rewardName: "神秘惊喜",
    stopIndex: 6,
    url: getOssOnlineImgFile("zaojuLottery/reward_yanjizhihe.png")
  },
  {
    rank: 21,
    rewardName: "火鸡便携消毒筷",
    stopIndex: 7,
    url: getOssOnlineImgFile("zaojuLottery/reward_daojia.png")
  }
];
//九宫格抽奖奖品
export const rewardPanList = [
  {
    rewardName: "谢谢参与",
    stopIndex: 0,
    url: getOssOnlineImgFile("userExperience/smile.png")
  },
  {
    rewardName: "老板全自动洗碗机F80",
    stopIndex: 1,
    url: getOssOnlineImgFile("userExperience/1.png")
  },
  {
    rewardName: "凌丰双耳珐琅汤锅",
    stopIndex: 2,
    url: getOssOnlineImgFile("userExperience/2.png")
  },
  {
    rewardName: "网红竹节玻璃杯",
    stopIndex: 3,
    url: getOssOnlineImgFile("userExperience/3.png")
  }
];
export function getDeviceInfo(currentNumber) {
  var item = {};
  if (currentNumber == "RRQZ") {
    item.deviceNumberName = "灶具";
    item.icon = getOssOnlineImgFile("ic_rqz.png");
  } else if (currentNumber == "RDCZ") {
    item.deviceNumberName = "燃气灶";
    item.icon = getOssOnlineImgFile("ic_rqz.png");  
  } else if (currentNumber == "RDKX") {
    item.deviceNumberName = "烤箱";
    item.icon = getOssOnlineImgFile("ic_dkx.png");
  } else if (currentNumber == "RZQL") {
    item.deviceNumberName = "蒸箱";
    item.icon = getOssOnlineImgFile("ic_dzx.png");
  } else if (currentNumber == "RZKY") {
    item.deviceNumberName = "一体机";
    item.icon = getOssOnlineImgFile("ic_ytj.png");
  } else if (currentNumber == "RWBL") {
    item.deviceNumberName = "微波炉";
    item.icon = getOssOnlineImgFile("ic_wbl.png");
  } else if (currentNumber == "RZNG") {
    item.deviceNumberName = "明火自动翻炒锅";
    item.icon = getOssOnlineImgFile("ic_wbl.png");
  } else if (currentNumber == "RIKA") {
    item.deviceNumberName = "集成烟机";
    item.icon = getOssOnlineImgFile("ic_wbl.png");
  } else if (currentNumber == "RJZC") {
    item.deviceNumberName = "集成灶";
    item.icon = getOssOnlineImgFile("ic_wbl.png");
  } else if (currentNumber == "RZZK") {
    item.deviceNumberName = "灶蒸烤一体机";
    item.icon = getOssOnlineImgFile("ic_wbl.png");
  }
  return item;
}
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
    //return value.toString().padStart(2, "0");
  });
  return time_str;
}
export function timeFormatter(duration) {
  let secondTime = parseInt(duration); //秒
  let minuteTime = 0; // 分
  let hourTime = 0; // 小时
  if (secondTime > 60) {
    // 如果秒数大于60，将秒数转换成整数
    // 获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    // 获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    // 如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      // 获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      // 获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  //let result = secondTime > 9 ? secondTime : ('0' + secondTime);
  let result = secondTime ? secondTime + "秒" : "";
  if (minuteTime > 0) {
    //result = (minuteTime > 9 ? minuteTime : ('0' + minuteTime)) + ":" + result;
    result = minuteTime + "分钟" + result;
  } else {
    //result = "00" + ":" + result;
  }
  if (hourTime > 0) {
    //result = (hourTime > 9 ? hourTime : ('0' + hourTime)) + ":" + result;
    result = hourTime + "小时" + result;
  } else {
    //result = "00" + ":" + result;
  }
  return result;
}
export function timeFormatterEn(duration) {
  let secondTime = parseInt(duration); //秒
  let minuteTime = 0; // 分
  let hourTime = 0; // 小时
  if (secondTime >= 60) {
    // 如果秒数大于60，将秒数转换成整数
    // 获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    // 获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    // 如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      // 获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      // 获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  //let result = secondTime > 9 ? secondTime : ('0' + secondTime);
  let result = secondTime ? secondTime + "s" : "";
  if (minuteTime > 0) {
    //result = (minuteTime > 9 ? minuteTime : ('0' + minuteTime)) + ":" + result;
    result = minuteTime + "min" + result;
  } else {
    //result = "00" + ":" + result;
  }
  if (hourTime > 0) {
    //result = (hourTime > 9 ? hourTime : ('0' + hourTime)) + ":" + result;
    result = hourTime + "h" + result;
  } else {
    //result = "00" + ":" + result;
  }
  return result;
}
export function compareVersion(v1, v2) {
  v1 = v1.split(".");
  v2 = v2.split(".");
  const len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push("0");
  }
  while (v2.length < len) {
    v2.push("0");
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }

  return 0;
}
export function isAtRokiMiniApplet() {
  var ua = navigator.userAgent.toLowerCase();
  let wxVersion = "";
  if (ua.indexOf("micromessenger") !== -1) {
    var match = ua.match(/micromessenger\/([\d.]+)/);
    if (match) {
      wxVersion = match[1];
    }
  }
  if (!ua.includes("miniProgram")) {
    return false;
  } //不在小程序内
  if (wxVersion) {
    //从微信 Android 8.0.16，iOS 8.0.17 开始，web-view 的 userAgent 中会携带小程序的 appid。
    if (ua.includes("Android") || ua.includes("Linux")) {
      //安卓
      if (
        compareVersion(wxVersion, "8.0.16") >= 0 &&
        ua.includes("wx9938a430413df67b")
      ) {
        console.log("new--version---appVersion-新版本--包含了appid---");
        return true;
      }
    } else {
      //ios
      if (
        compareVersion(wxVersion, "8.0.17") >= 0 &&
        ua.includes("wx9938a430413df67b")
      ) {
        console.log("new--version---appVersion-新版本--包含了appid---");
        return true;
      }
    }
  }
  return false; //两种情况：1.微信版本太低，导致无法判断是否在roki app内；2.webview的userAgent里没有携带小程序的appid
} //判断是否在roki 美食的微信小程序中
export const browser = {
  versions: (function() {
    let u = navigator.userAgent;
    return {
      isWeixin: u.indexOf("MicroMessenger") > -1,
      isWeibo: u.match(/WeiBo/i) == "weibo",
      isQQSpace: u.match(/QQ/i) == "qq",
      trident: u.indexOf("Trident") > -1,
      presto: u.indexOf("Presto") > -1,
      webKit: u.indexOf("AppleWebKit") > -1,
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1,
      mobile:
        !!u.match(/AppleWebKit.*Mobile/i) ||
        !!u.match(
          /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/
        ),
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
      iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1,
      iPad: u.indexOf("iPad") > -1,
      iPod: u.indexOf("iPod") > -1,
      webApp: u.indexOf("Safari") === -1,
      openHarmony: u.includes("OpenHarmony"),
      isAtMiniProgram: u.includes("miniProgram"), //是否在小程序中
      isAtRokiApplet: isAtRokiMiniApplet() //h5是否在roki美食小程序中打开--从微信 Android 8.0.16，iOS 8.0.17 开始，web-view 的 userAgent 中会携带小程序的 appid
    };
  })()
};
export function getElementLeft(element) {
  var actualLeft = element.offsetLeft;
  var current = element.offsetParent;
  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  return actualLeft;
}
export function getElementTop(element) {
  var actualTop = element.offsetTop;
  var current = element.offsetParent;
  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  return actualTop;
}
export function getBoundingClientRect(element) {
  var scrollTop = document.documentElement.scrollTop;
  var scrollLeft = document.documentElement.scrollLeft;
  if (element.getBoundingClientRect) {
    // if (typeof arguments.callee.offset != "number") {
    //     var temp = document.createElement("div");
    //     temp.style.cssText = "position:absolute;left:0;top:0;"; document.body.appendChild(temp);
    //     arguments.callee.offset = -temp.getBoundingClientRect().top - scrollTop; document.body.removeChild(temp);
    //     temp = null;
    // }//在IE7及更早的版本中位于左上角（0，0）处的元素的位置会返回（2，2）的坐标
    var rect = element.getBoundingClientRect();
    // var offset = arguments.callee.offset;
    var offset = 0;
    return {
      left: rect.left + offset,
      right: rect.right + offset,
      top: rect.top + offset,
      bottom: rect.bottom + offset
    };
  } else {
    var actualLeft = getElementLeft(element);
    var actualTop = getElementTop(element);
    return {
      left: actualLeft - scrollLeft,
      right: actualLeft + element.offsetWidth - scrollLeft,
      top: actualTop - scrollTop,
      bottom: actualTop + element.offsetHeight - scrollTop
    };
  }
}
export function hasClass(el, className) {
  let reg = new RegExp("(^|\\s)" + className + "(\\s|$)");
  return reg.test(el.className);
}
export function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }
  let newClass = el.className.split(" ");
  newClass.push(className);
  el.className = newClass.join(" ");
}
export function removeClass(ele, className) {
  if (hasClass(ele, className)) {
    const reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}
/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;
  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}
/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}
// 将首字母转为大写
export function titleCase(str) {
  return str.replace(/( |^)[a-z]/g, L => L.toUpperCase());
}
//验证是否是数字，包括0，正数，负数，小数。。。
export function isNumberStr(str) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str);
}
/**深度克隆对象
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}
/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}
/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children"
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}
//判断当前用户userId----仅用于活动判断
export function judgeUserLogin() {
  const userId = localStorage.getItem("terminalUserId"); //只存于app端webview缓存
  if (userId) {
    return userId;
  }
  const userInfo = JSON.parse(localStorage.getItem("userInfokey")); //web端缓存
  return userInfo && userInfo.id ? userInfo.id : "";
}

export function getFavoriteRecipeAssitSign(actId, workId, shareUserId, userId) {
  const str = `activityId=${actId}&creationId=${workId}&shareUserId=${shareUserId}&userId=${userId}`;
  const key = "Robam@2022*03";
  const sign = hmacSHAsign(key, str);
  return sign;
}
/**
 * 增强版节流函数
 * @param {Function} fn 需要节流的函数
 * @param {number} delay 延迟时间
 * @param {Object} options 配置选项
 * @returns {Function} 节流后的函数
 */
export const throttle = (fn, delay = 500, options = {}) => {
  let timer = null;
  let lastTime = 0;

  // 默认配置
  const defaultOptions = {
    leading: true, // 是否立即执行
    trailing: true // 是否延迟执行
  };

  const finalOptions = { ...defaultOptions, ...options };

  const throttled = function(...args) {
    const now = Date.now();

    // 首次执行时，如果不需要立即执行，则将上次执行时间设置为当前时间
    if (!lastTime && !finalOptions.leading) {
      lastTime = now;
    }

    const remaining = delay - (now - lastTime);

    if (remaining <= 0) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      fn.apply(this, args);
      lastTime = now;
    } else if (!timer && finalOptions.trailing) {
      timer = setTimeout(() => {
        fn.apply(this, args);
        lastTime = finalOptions.leading ? Date.now() : 0;
        timer = null;
      }, remaining);
    }
  };

  // 取消方法
  throttled.cancel = () => {
    clearTimeout(timer);
    timer = null;
    lastTime = 0;
  };

  return throttled;
};



// WEBPACK FOOTER //
// ./src/utils/index.js